import React from 'react';
import { PapiUser } from '@wix/da-types-papi';
import { withTranslation, WithTranslation } from 'react-i18next';
import CommentThread from '@wix/da-shared-react/pkg/CommentThread';
import { CommentableTypes } from '@wix/da-shared-react/pkg/Comment/types';
import {
  BiLoggerContextProvider,
  BiDataHook,
} from '@wix/da-shared-react/pkg/biLogger';
import WidgetBox, { Props as WidgetBoxProps } from '../_partials/WidgetBox';

export type Props = {
  currentUser: PapiUser;
  profileOwnerUser: PapiUser;
  isOwner: boolean;
  isMobile: boolean;
  totalCount: number;
} & Pick<WidgetBoxProps, 'moduleId' | 'section' | 'zone'>;

export class ProfileCommentsBox extends React.Component<
  Props & WidgetBoxProps & WithTranslation
> {
  render() {
    const { widgetRemove, isMobile, section, zone, ...props } = this.props;

    return (
      <WidgetBox
        section={section}
        zone={zone}
        header={isMobile ? null : props.t!('widgets.profileComments.header')}
        count={isMobile ? undefined : props.totalCount}
        moduleId={props.moduleId}
        widgetRemove={widgetRemove}
        dataHook={BiDataHook.WIDGET_PROFILE_COMMENTS}
      >
        <div>
          <BiLoggerContextProvider
            value={{ widgetname: 'comments', sectionname: 'comments' }}
          >
            <CommentThread
              currentUser={props.currentUser}
              commentableTypeId={CommentableTypes.COMMENT_USER}
              commentableItemId={props.profileOwnerUser.userId}
              useCardLayout
              postbox="top"
              statsAndControls={isMobile ? 'on' : 'off'}
              compact
            />
          </BiLoggerContextProvider>
        </div>
      </WidgetBox>
    );
  }
}

export default withTranslation()(ProfileCommentsBox) as React.ComponentType<
  Props
>;
